// src/components/MangoHero/MangoHero.jsx
import React from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./mango-hero.css";

const MangoHero = ({ slides }) => {
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: false,
    pauseOnHover: true,
    ltr: true,
  };

  return (
    <section className="mango-hero">
      <Slider {...sliderSettings} className="mango-hero-slider">
        {slides.map((slide, index) => (
          <div key={index} className="mango-hero-slide">
            <div
              className="mango-hero-bg"
              style={{ backgroundImage: `url(${slide.img})` }}
            >
              <div className="mango-hero-overlay">
                <div className="mango-hero-container">
                  <div className="mango-hero-content">
                    <span className="mango-hero-badge">
                      🍋 Fresh Mango Season!
                    </span>
                    <h1 className="mango-hero-headline">{slide.headline}</h1>
                    <h2 className="mango-hero-subheadline">
                      {slide.subheadline}
                    </h2>
                    <div className="mango-hero-cta">
                      <Link to="/mango" className="btn btn-primary mango-btn">
                        {slide.primaryBtn}
                      </Link>
                      <Link
                        to="/menu"
                        className="btn btn-secondary mango-btn-outline"
                      >
                        View Regular Menu
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </section>
  );
};

export default MangoHero;
